module.exports = {"apiUrl":"https://api.storage.garvex.tech","azsUrl":"https://azs-online.ru","monUrl":"https://mt.garvex.tech"};